var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3572 1.5C9.01491 1.5 7.90909 2.60582 7.90909 3.94815V4.77273H3V6.40909H4.63636V20.3182C4.63636 21.6669 5.74219 22.7727 7.09091 22.7727H16.9091C18.2578 22.7727 19.3636 21.6669 19.3636 20.3182V6.40909H21V4.77273H16.0909V3.94815C16.0909 2.60582 14.9851 1.5 13.6428 1.5H10.3572ZM10.3572 3.13636H13.6428C14.103 3.13636 14.4545 3.48793 14.4545 3.94815V4.77273H9.54545V3.94815C9.54545 3.48793 9.89702 3.13636 10.3572 3.13636ZM6.27273 6.40909H17.7273V20.3182C17.7273 20.7784 17.3693 21.1364 16.9091 21.1364H7.09091C6.63068 21.1364 6.27273 20.7784 6.27273 20.3182V6.40909ZM7.90909 8.04545V19.5H9.54545V8.04545H7.90909ZM11.1818 8.04545V19.5H12.8182V8.04545H11.1818ZM14.4545 8.04545V19.5H16.0909V8.04545H14.4545Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.6a66987259b11dd952bfbe890ea78f00.svg";
export { ForwardRef as ReactComponent };